import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import './Footer.css';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-grid">
            {/* О проекте */}
            <div className="footer-column">
              <h3 className="footer-title">{t('home.footer.about.title')}</h3>
              <p className="footer-description">
                {t('home.footer.about.description')}
              </p>
            </div>

            {/* Навигация */}
            <div className="footer-column">
              <h3 className="footer-title">{t('home.footer.navigation.title')}</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/" className="footer-link">{t('common.home')}</Link>
                </li>
                {/* <li>
                  <Link to="/playgrounds" className="footer-link">{t('common.playgrounds')}</Link>
                </li>
                <li>
                  <Link to="/meetings" className="footer-link">{t('common.meetings')}</Link>
                </li>
                <li>
                  <Link to="/create-meeting" className="footer-link">{t('common.createMeeting')}</Link>
                </li> */}
              </ul>
            </div>

            {/* Для арендодателей */}
            <div className="footer-column">
              <h3 className="footer-title">{t('home.footer.landlords.title')}</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/for-landlords" className="footer-link">
                    {t('common.forLandlords')}
                  </Link>
                </li>
                <li>
                  <a 
                    href={import.meta.env.PROD ? 'https://admin.sportsground.ru' : 'http://localhost:3000'} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    {t('common.enterAdmin')}
                  </a>
                </li>
                <li>
                  <a 
                    href={import.meta.env.PROD ? 'https://admin.sportsground.ru/registration' : 'http://localhost:3000/registration'} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    {t('common.registerPlayground')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Инвесторам */}
            <div className="footer-column">
              <h3 className="footer-title">{t('home.footer.investors.title')}</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/investors" className="footer-link">{t('common.investorsInfo')}</Link>
                </li>
              </ul>
            </div>

            {/* Аккаунт
            <div className="footer-column">
              <h3 className="footer-title">{t('home.footer.account.title')}</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/login" className="footer-link">{t('common.login')}</Link>
                </li>
                <li>
                  <Link to="/registration" className="footer-link">{t('common.registration')}</Link>
                </li>
                <li>
                  <Link to="/profile" className="footer-link">{t('common.profile')}</Link>
                </li>
              </ul>
            </div>
            */}
          </div>

          {/* Нижняя часть */}
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>{t('common.copyright')}. {t('common.allRightsReserved')}.</p>
            </div>
            <div className="footer-legal">
              <Link to="/ambassador-rules" className="footer-legal-link">
                {t('common.ambassadorRules')}
              </Link>
              <span className="footer-separator">•</span>
              <Link to="/terms" className="footer-legal-link">{t('common.termsOfUse')}</Link>
              <span className="footer-separator">•</span>
              <Link to="/privacy" className="footer-legal-link">{t('common.privacyPolicy')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
